module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/package-icon-f917ab7a9e8f8879a796a8be975a6eab.png";